"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FractionalIndex = void 0;
var big_js_1 = __importDefault(require("big.js"));
big_js_1.default.DP = 1000000;
var compress = function (ns) {
    ns = ns.slice(1);
    var rs = ['.'];
    for (var i = 0; i < ns.length;) {
        var e = i;
        for (; e < ns.length && (e - i) < 25; e++) {
            if (ns[e] !== '9')
                break;
        }
        if (i !== e) {
            rs.push(String.fromCharCode('A'.charCodeAt(0) + (e - i)));
            i = e;
        }
        else {
            rs.push(ns.slice(i));
            break;
        }
    }
    return rs.join('');
};
var uncompress = function (cns) {
    var e_1, _a;
    if (cns === '0' || cns === '1')
        return cns;
    var r = [];
    try {
        for (var cns_1 = __values(cns), cns_1_1 = cns_1.next(); !cns_1_1.done; cns_1_1 = cns_1.next()) {
            var c = cns_1_1.value;
            if (c > '9') {
                var a = c.charCodeAt(0) - 65;
                for (var x = 0; x < a; x++) {
                    r.push('9');
                }
            }
            else {
                r.push(c);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (cns_1_1 && !cns_1_1.done && (_a = cns_1.return)) _a.call(cns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return r.join('');
};
var findLeftRightForBefore = function (index, target) {
    var e_2, _a, e_3, _b;
    if (target) {
        var l = null;
        var r = index[target];
        try {
            for (var _c = __values(Object.keys(index)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var id = _d.value;
                if (id === '__v')
                    continue;
                var wx = index[id];
                if (l === null && wx < r)
                    l = wx;
                if (wx > l && wx < r)
                    l = wx;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return [l !== null && l !== void 0 ? l : '0', r];
    }
    else {
        var l = null;
        var r = '1';
        try {
            for (var _e = __values(Object.keys(index)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var id = _f.value;
                if (id === '__v')
                    continue;
                var wx = index[id];
                if (l === null || wx > l)
                    l = wx;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return [l !== null && l !== void 0 ? l : '0', r];
    }
};
var truncate = function (ns) {
    if (!ns.startsWith('.'))
        return ns;
    if (ns.length < 12)
        return ns;
    var d = ns[1];
    if (d !== '0' && d !== '9')
        return ns;
    var i = 2;
    for (; i < ns.length; i++) {
        if (ns[i] !== d)
            break;
    }
    if (i === ns.length)
        return ns;
    return ns.slice(0, i + 10);
};
var computeKey = function (l, r) {
    // Hard coded special case
    if (l === '0' && r === '1')
        return '.5';
    // Convert to Bigz
    var a = new big_js_1.default(uncompress(l));
    var b = new big_js_1.default(uncompress(r));
    // Compute new weight
    var x = a.add(b).div(2).toFixed().substr(1);
    // Truncate and compress
    var xtc = compress(truncate(x));
    return xtc;
};
var insertBefore = function (index, target) {
    var leftRight = findLeftRightForBefore(index, target);
    var key = computeKey.apply(void 0, __spreadArray([], __read(leftRight), false));
    return key;
};
exports.FractionalIndex = Object.freeze({
    insertBefore: insertBefore,
});
